import React from "react"
import ReleaseItem from "../../lib/models/ReleaseItem";
import './ReleaseCard.scss';

interface Props {
    item: ReleaseItem;
}

interface State { }

export default class ReleaseCard extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        const s3URL = this.props.item.s3Location ? ReleaseCard.s3URL(this.props.item) : undefined;
        const formattedDate = new Intl.DateTimeFormat('en-US', { year: '2-digit', month: 'short', day: '2-digit', hour: 'numeric', minute: 'numeric' }).format(Date.parse(this.props.item.deployedAt));

        return <div className='releaseCard'>
            <div className='data'>
                <div><a href={ReleaseCard.pipelineURL(this.props.item)}>{this.props.item.version}</a></div>
                {s3URL
                    ? <div className='right'><a href={ReleaseCard.s3URL(this.props.item)}>S3</a></div>
                    : <></>}
            </div>
            <div className='data smaller'>
                <div>{formattedDate}</div>
                <div className='right'>{this.props.item.versionMatch}</div>
            </div>
        </div>;
    }

    private static pipelineURL(item: ReleaseItem) {
        return `https://us-west-1.console.aws.amazon.com/codesuite/codepipeline/pipelines/${item.name}/executions/${item.pipelineExecutionId}/visualization?region=us-west-1`;
    }

    private static s3URL(item: ReleaseItem) {
        try {
            const url = new URL(item.s3Location);

            return `https://us-west-1.console.aws.amazon.com/s3/object/${url.host}?region=us-west-1&bucketType=general&prefix=${url.pathname.replace(/^[/]/, '')}`;
        }
        catch {
            return undefined;
        }
    }
}